import ProductContractCard from "components/molecules/card/product-contract/ProductContractCard";
import ListWrapper from "components/molecules/list-wrapper/ListWrapper";
import { TopBar } from "components/organisms";
import { TopbarPage } from "components/templates";
import { useFormikContext } from "formik";
import { useTranslation } from "react-i18next";

interface ISettlementInfoContractForm {
  id: string;
  contractId: string;
  startDate: string;
  endDate: string | null;
  isActive: boolean;
  labelId: string;
  labelName: string;
  divisionPercentage: number;
  contractName: string;
}

interface IPerTrackContract {
  title: string;
  trackId: string;
  contracts: ISettlementInfoContractForm[];
}

interface ISettlementInfo {
  perTrackSettlement: boolean;
  contracts: ISettlementInfoContractForm[];
  perTrackContracts: IPerTrackContract[];
}

type ListItem =
  | { type: "header"; trackTitle: string; trackId: string }
  | { type: "contract"; contract: ISettlementInfoContractForm };

const ContractsPerTrackTab = <Form extends Record<string, ISettlementInfo>>({
  propertyName = "settlementInfo",
}: {
  propertyName?: keyof Form;
}) => {
  const { values, status }: any = useFormikContext<Form>();
  const { t } = useTranslation();

  const settlementInfo = values[propertyName] as ISettlementInfo;

  const perTrackItems: ListItem[] = settlementInfo.perTrackContracts.flatMap(
    (track) => [
      { type: "header", trackTitle: track.title, trackId: track.trackId },
      ...track.contracts.map((c) => ({
        type: "contract" as const,
        contract: c,
      })),
    ]
  );

  return (
    <TopbarPage
      topbar={
        <TopBar
          customBackItem={<div />}
          title={`${t("input.label.global")}
          `}
        />
      }
    >
      <ListWrapper
        isLoading={status?.isLoading}
        items={settlementInfo.contracts}
        item={(contract: ISettlementInfoContractForm, index: number) => (
          <ProductContractCard key={index} contract={contract} />
        )}
      />

      {settlementInfo.perTrackSettlement && perTrackItems.length > 0 && (
        <div className="w-full pt-[40px]">
          <ListWrapper
            isLoading={status?.isLoading}
            items={perTrackItems}
            item={(item: ListItem, index: number) =>
              item.type === "header" ? (
                <TopBar
                  key={item.trackId}
                  customBackItem={<div />}
                  title={item.trackTitle}
                ></TopBar>
              ) : (
                <ProductContractCard
                  key={item.contract.id}
                  contract={item.contract}
                />
              )
            }
          />
        </div>
      )}
    </TopbarPage>
  );
};

export default ContractsPerTrackTab;
